// Copyright ©️ 2026 eVolve MEP, LLC

import type { BendTypeName } from '@evolvemep/api-ts';
import { Stack } from '@mantine/core';

import { ToggleRadioGroup } from 'components/Mantine/TypeSafeSelect/ToggleRadioGroup';
import { useBendCreatorValidationContext } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/Context/useBendCreatorValidationContext';
import { useBendTypes } from 'modules/Shop/EvolveFabrication/BendCreator/useBendTypes';

import { BendTypeIcon } from './BendTypeIcon';
const BendTypeLabel = ({ bendType }: { bendType: BendTypeName }) => (
  <Stack align="center">
    <BendTypeIcon bendType={bendType} />
    {bendType}
  </Stack>
);

export const BendTypeSelect = () => {
  const { bendTypes, loading } = useBendTypes();
  const { fieldGetInputProps } = useBendCreatorValidationContext();
  return (
    <ToggleRadioGroup
      label="Shape"
      // TODO: re-add custom. It must be added manually, similar to the below code for the old `WrappedSelect` component:
      // data={isNil(bendTypes) ? [] : [...bendTypes.map(({ name }) => name), 'Custom']}
      data={
        bendTypes
          ?.map(({ name }) => ({ id: name, label: <BendTypeLabel bendType={name} />, value: name }))
          .concat([{ id: 'Custom', label: <BendTypeLabel bendType="Custom" />, value: 'Custom' }]) ?? []
      }
      loading={loading}
      required
      variant="card"
      cols={2}
      {...fieldGetInputProps.bendType()}
    />
  );
};
